import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

const generatePdf = async (formElement) => {
  formElement.classList.add('pdf-export');

  // Use a higher scale for better text clarity (but not too high for file size)
  const canvas = await html2canvas(formElement, { scale: 2, backgroundColor: '#fff' });

  const imgData = canvas.toDataURL('image/jpeg', 0.85);
  const pdf = new jsPDF('p', 'mm', 'a4');
  const pdfWidth = pdf.internal.pageSize.getWidth();
  const pdfHeight = pdf.internal.pageSize.getHeight();

  // Convert px to mm
  const pxPerMm = canvas.width / pdfWidth;
  const pageHeightPx = pdfHeight * pxPerMm;

  let pageY = 0;
  let pageNum = 0;

  while (pageY < canvas.height) {
    // Create a new canvas for each page slice
    const pageCanvas = document.createElement('canvas');
    pageCanvas.width = canvas.width;
    pageCanvas.height = Math.min(pageHeightPx, canvas.height - pageY);
    const ctx = pageCanvas.getContext('2d');
    ctx.fillStyle = '#fff';
    ctx.fillRect(0, 0, pageCanvas.width, pageCanvas.height);
    ctx.drawImage(canvas, 0, -pageY);

    const pageImgData = pageCanvas.toDataURL('image/jpeg', 0.85);

    if (pageNum > 0) pdf.addPage();
    pdf.addImage(pageImgData, 'JPEG', 0, 0, pdfWidth, (pageCanvas.height / pxPerMm));

    pageY += pageHeightPx;
    pageNum++;
  }

  formElement.classList.remove('pdf-export');
  return pdf.output('blob');
};

export default generatePdf;